<div class="row consultas-container" style="font-family: 'Mulish', sans-serif;">
  <div class="col" *ngIf="isLoading" style="min-height: 40px !important;">
        <div class="loader">
          <div class="loader__figure"></div>
          <p class="loader__label"></p>
        </div>
      </div> 
<div *ngIf="consultas_pasadas_ui.length == 0 && !isLoading" class="card-alerta">    <table>
      <tr>
        <td class="p-3"><i class="fi fi-rr-info"
            style="color: #1a237e; font-size: larger;display: flex; justify-content: center;"></i></td>
        <td>
          <p class="letras-alerta">No se registran consultas previas.</p>
        </td>
      </tr>
    </table>
  </div>
<div *ngFor="let appt of consultas_pasadas_ui; let i = index" class="rounded p-3 mb-2">
    <!-- Encabezado -->
    <div class="appt-card p-0">
      <!-- Fila superior: fecha/hora + Estado -->
      <div class="d-flex justify-content-between align-items-start pb-2">
        <div class="d-flex align-items-center">
          <h6 class="mb-0"
            style="font-weight:700; color:#1a237e; font-size: 12px; display: flex; align-items: center; font-family: 'Mulish';">
            <i class="d-flex fi fi-rr-calendar"></i>
            {{ appt.tel_doc_app_appointment_date.day }} de {{ appt.tel_doc_app_appointment_date.month }} del {{ appt.tel_doc_app_appointment_date.year }}
- {{ appt.horaConsulta }} horas

          </h6>
        </div>
        <ng-container *ngIf="expandedIndex !== i; else linkSuperior">
          <small class="text-muted" style="font-weight:600; font-size: 12px;">
            {{ appt.sta_name | titlecase }}
          </small>
        </ng-container>
        <ng-template #linkSuperior>
          <a href="javascript:void(0)" (click)="verDetalle(i)" class="appt-link"
            style="font-size: 12px; display: flex; align-items: center;">
            <i class="d-flex fi fi-rr-angle-small-left"></i> Ver menos </a>
        </ng-template>
      </div>

      <!-- Diagnósticos como “chips” -->
      <div *ngIf="expandedIndex !== i" class="mb-2" style="display: flex; justify-content: center;">
        <div class="row w-100">
          <ng-container *ngFor="let dx of appt.diagnosticos">
            <div class="col-12 col-lg-12 mb-1" style="padding: 0 2px; display: flex; flex-direction: column;"
              >
              <span class="badge badge-pill appt-pill2 w-100 text-truncate text-align-start"[ngClass]="dx.dia_name ? 'appt-pill2' : 'appt-pill3'" style="text-align: left;"
                [title]="dx.dia_name">
                <p class="m-0 d-block text-truncate one-line-ellipsis"><strong>
                    Diagnostico:
                  </strong>
                  {{ dx.detail }}
                </p>
                <p  class="m-0 d-block text-truncate one-line-ellipsis">
                  <strong>
                    Indicaciones:
                  </strong>
                  {{ dx.indication }}
                </p>
              </span>
              <span *ngIf="dx.dia_name" class="badge badge-pill appt-pill w-100 text-truncate text-align-start" style="text-align: left;"
                [title]="dx.dia_name">
               {{ dx.dia_cie10}}: {{ dx.dia_name }}
              </span>
            </div>
          </ng-container>
        </div>
      </div>

      <hr class="mt-1 mb-1" style="border-color: #99abb4;">
      <!-- Fila inferior: médico + Ver detalle -->
      <div *ngIf="expandedIndex !== i" class="d-flex justify-content-between align-items-center mt-2">
        <div class="text-muted d-flex align-items-center">
          <i class="fi fi-rr-user-md"></i>
          <small>{{ appt.nombreMedico }} - {{ appt.subspe_name }}</small>
        </div>

        <a href="javascript:void(0)" (click)="verDetalle(i)" class="appt-link"
          style="font-size: 12px; display: flex; align-items: center;">
          {{ expandedIndex === i ? 'Ocultar' : 'Ver detalle' }}
        </a>
      </div>
    </div>


    <!-- Contenido expandible -->
    <div *ngIf="expandedIndex === i" class="animated-fade">
      <div class="border-top">
        <!-- Información del doctor -->
        <div class="d-flex  text-muted mb-2 mt-2 small" style="justify-content: space-around;">
          <div> <i class="fi fi-rr-user-md"></i> Profesional
            <br>
            <span style="color: black; font-weight: 700;">
              {{ appt.nombreMedico }}
            </span>
          </div>
          <div><i class="fi fi-rr-stethoscope"></i> Área
            <br>
            <span style="color: black; font-weight: 700;">
              {{appt.subspe_name }}
            </span>
          </div>
          <!-- <div><i class="fi fi-rr-stethoscope"></i> Subespecialidad
            <br>
            <span style="color: black; font-weight: 700;">
              {{ appt.subspe_name || 'N/A' }}
            </span>
          </div> -->
        </div>
        <hr class="mt-1 mb-1" style="border-color: #99abb4;">

        <!-- Tabs -->
        <div class="text-muted mb-2" style="display: flex; align-items: center;">
          <i class="fi fi-rr-edit"></i>
          <span style="font-weight: 500; font-size: 12px;"> Generado </span>
        </div>

        <!-- Tabs -->
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item" *ngFor="let tab of tiposDocumentosTabs">
            <a class="nav-link" [ngClass]="{ 'active': selectedTab === tab.id }" (click)="selectedTab = tab.id"
              href="javascript:void(0)" style="display:flex; align-items:center;">
              <i [ngClass]="tab.icon"></i>
              <span class="ml-1">{{ tab.label }}</span>
            </a>
          </li>
        </ul>


        <!-- Contenido de tabs -->
        <div class="tab-content">
          <div [ngSwitch]="selectedTab">

            <!-- Anamnesis -->
            <div *ngSwitchCase="'anamnesis'" class="tab-pane fade show active">
              <div *ngIf="!appt.med_con_his_anamnesis" class="p-3"
                style="background-color: #DAEAFB; border-radius: 15px; display: flex; align-items: center;">
                <i class="d-flex fi fi-rr-info"></i>
                No existe una anamnesis en esta consulta.
              </div>
              <div class="rounded p-1" *ngIf="appt.med_con_his_anamnesis" style="box-shadow: none;">
                <h1 class="titulo-card mb-0"><i class="fi fi-rr-stethoscope"></i> Anamnesis</h1>
                <div class="rounded p-0 pt-2" style="box-shadow: none;    font-size: 12px;">
                  <p>
                    {{ appt.med_con_his_anamnesis }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Diagnósticos e indicaciones -->
            <div *ngSwitchCase="'diagnosticos'" class="tab-pane fade show active">
              <div *ngIf="appt.diagnosticos?.length == 0" class="p-3"
                style="background-color: #DAEAFB; border-radius: 15px; display: flex; align-items: center;">
                <i class="d-flex fi fi-rr-info"></i>
                No existen diagnosticos en esta consulta.
              </div>
              <div class="rounded p-0" style="box-shadow: none;" *ngIf="appt.diagnosticos?.length  > 0">
                <div class="rounded mb-2" *ngFor="let diagnostico of appt.diagnosticos"
                  style="box-shadow: 0px 0px 10px #92929282; border-radius: 5px !important;">
                  <h1 class="fecha-card">
                    {{ diagnostico.att_date }} - {{ diagnostico.att_date1 | date: 'HH:mm' }} horas
                    <i class="fi fi-rr-download"
                      (click)="_generalServices.descargarFileAtt(diagnostico.att_id, diagnostico.file_name_desc, null)"></i>

                  </h1>
                  <div>
                    <p class="diagnostico-border">
                      <i class="d-flex fi fi-rr-doctor"></i>
                      {{ diagnostico.dia_name }}
                    </p>
                  </div>
                  <p style="font-size: 12px;">{{ diagnostico.detail }}</p>
                  <p class="text-muted" style="font-size: 12px;">{{ diagnostico.indication }}</p>
                </div>
              </div>
            </div>

            <!-- Recetas -->
            <div *ngSwitchCase="'recetas'" class="tab-pane fade show active">
              <div *ngIf="appt.prescripciones?.length == 0" class="p-3"
                style="background-color: #DAEAFB; border-radius: 15px; display: flex; align-items: center;">
                <i class="d-flex fi fi-rr-info"></i>
                No existen recetas en esta consulta.
              </div>
              <div class="rounded p-0" style="box-shadow: none;" *ngIf="(appt.prescripciones?.length || 0) > 0">
                <div class="rounded mb-2" *ngFor="let receta of appt.prescripciones"
                  style="box-shadow: 0px 0px 10px #92929282; border-radius: 5px !important;">
                  <h1 class="fecha-card">
                    {{ receta.att_date }} - {{ receta.att_date1 | date: 'HH:mm' }} horas
                    <i class="fi fi-rr-download"
                      (click)="_generalServices.descargarFileAtt(receta.att_id, receta.file_name_desc, null)"></i>
                  </h1>
                  <div>
                    <p class="diagnostico-border">
                      <i class="d-flex fi fi-rr-document-signed"></i>
                      {{ receta.pre_typ_name }}
                    </p>
                  </div>
                  <p style="font-size: 12px;">{{ receta.indication }}</p>
                </div>
              </div>
            </div>

            <!-- Certificados -->
            <div *ngSwitchCase="'certificados'" class="tab-pane fade show active">
              <div *ngIf="getCertificadosTipoCertificado(appt).length == 0" class="p-3"
                style="background-color: #DAEAFB; border-radius: 15px; display: flex; align-items: center;">
                <i class="d-flex fi fi-rr-info"></i>
                No existen certificados en esta consulta.
              </div>
              <div class="rounded p-0" style="box-shadow: none;"
                *ngIf="getCertificadosTipoCertificado(appt)?.length  > 0">
                <div class="rounded mb-2" *ngFor="let certificado of getCertificadosTipoCertificado(appt)"
                  style="box-shadow: 0px 0px 10px #92929282; border-radius: 5px !important;">
                  <h1 class="fecha-card">
                    {{ certificado.att_date }} - {{ certificado.att_date1 | date: 'HH:mm' }} horas
                    <i class="fi fi-rr-download"
                      (click)="_generalServices.descargarFileAtt(certificado.att_id, certificado.file_name_desc, null)"></i>
                  </h1>

                  <p class="pt-2" style="font-size: 12px;">{{ certificado.comment }}</p>
                </div>
              </div>
            </div>

            <!-- Órdenes de exámenes -->
            <div *ngSwitchCase="'examenes'" class="tab-pane fade show active">
              <div *ngIf="getCertificadosTipoExamen(appt).length == 0" class="p-3"
                style="background-color: #DAEAFB; border-radius: 15px; display: flex; align-items: center;">
                <i class="d-flex fi fi-rr-info"></i>
                No existen ordenes en esta consulta.
              </div>
              <div class="rounded p-0" style="box-shadow: none;" *ngIf="getCertificadosTipoExamen(appt)?.length  > 0">
                <div class="rounded mb-2" *ngFor="let examenen of getCertificadosTipoExamen(appt)"
                  style="box-shadow: 0px 0px 10px #92929282; border-radius: 5px !important;">
                  <h1 class="fecha-card">
                    {{ examenen.att_date }} - {{ examenen.att_date1 | date: 'HH:mm' }} horas
                    <i class="fi fi-rr-download"
                      (click)="_generalServices.descargarFileAtt(examenen.att_id, examenen.file_name_desc, null)"></i>
                  </h1>
                  <div>
                    <p class="diagnostico-border">
                      <i class="d-flex fi fi-rr-document"></i>
                      {{ examenen.exa_typ_name }}
                    </p>
                  </div>
                  <p style="font-size: 12px;">{{ examenen.comment }}</p>
                </div>
              </div>
            </div>

            <!-- Licencias (si tienes una fuente de datos, ajusta aquí) -->
            <div *ngSwitchCase="'licencias'" class="tab-pane fade show active">
              <div *ngIf="appt.medical_leaves?.length == 0" class="p-3"
                style="background-color: #DAEAFB; border-radius: 15px; display: flex; align-items: center;">
                <i class="d-flex fi fi-rr-info"></i>
                No existen licencias en esta consulta.
              </div>
              <div class="rounded p-0" style="box-shadow: none;" *ngIf="appt.medical_leaves?.length  > 0">
                <div class="rounded mb-2" *ngFor="let licencia of appt.medical_leaves"
                  style="box-shadow: 0px 0px 10px #92929282; border-radius: 5px !important;">
                  <h1 class="fecha-card">
                    {{ licencia.med_lea_request_date }} - {{ licencia.med_lea_request_date1 | date: 'HH:mm' }} horas
                  </h1>
                  <div>
                    <p class="diagnostico-border">
                      <i class="d-flex fi fi-rr-document"></i>
                      {{ licencia.sta_name }}
                    </p>
                  </div>
                  <p class="m-0" style="font-size: 12px;">Diagnostico: {{licencia.dia_cie10}}- {{ licencia.dia_name }}
                  </p>
                  <p class="m-0" style="font-size: 12px; white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;">Diagnostico médico: {{licencia.dia_det_diagnostic_detail}}</p>
                  <p class="m-0" style="font-size: 12px;">Fecha inicio de reposo: {{ licencia.med_lea_start_date }}</p>
                  <p class="m-0" style="font-size: 12px;">Días de reposo: {{ licencia.med_lea_days }}</p>
                  <p class="m-0" style="font-size: 12px;">Tipo de licencia: {{ licencia.med_lev_typ_name }}</p>
                </div>
              </div>
            </div>

            <div *ngSwitchCase="'otros'" class="tab-pane fade show active">
              <div *ngIf="appt.documentosMedico?.length == 0" class="p-3"
                style="background-color: #DAEAFB; border-radius: 15px; display: flex; align-items: center;">
                <i class="d-flex fi fi-rr-info"></i>
                No existen documentos adjuntos en esta consulta.

              </div>
              <div class="table-responsive table table-sm " *ngIf="appt.documentosMedico.length > 0">
  <table class="table table-sm custom-table m-0">
    <thead class="tabla-docs">
      <tr>
        <th>Nombre</th>
        <th>Fecha</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let doc of appt.documentosMedico; let i = index"
          [ngClass]="{ 'row-alt': (i % 2 === 0) }">
        <!-- <td class="font-weight-bold text-primary-700">
          {{ getNombreDocumento(doc) }}
        </td> -->
        <td>
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center justify-content-center">
                  <i class="fi fi-rr-document"></i>
                </div>
                <div class="nombre-doc ml-2">
                  <div class="nombre-principal">
          {{ getNombreDocumento(doc) }}
                  </div>
                  <!-- <div class="nombre-secundario text-align-start">
                    {{ doc.tipo_doc || doc.att_typ_name | titlecase }}
                  </div> -->
                  
                </div>
              </div>
            </td>

        <td>{{ doc.att_date | date : 'dd/MM/yyyy' }}</td>

        <td class="text-center">
          <i class="fi fi-rr-download"
             (click)="_generalServices.descargarFileAtt(doc.att_id, doc.file_name_desc, null)"></i>
        </td>
      </tr>
    </tbody>
  </table>
</div>

            </div>

          </div>
        </div>



      </div>
    </div>

  </div>
</div>